import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssignUser = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_3037_3871)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 30,
					cy: 30,
					r: 30,
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 30,
					cy: 24.75,
					r: 6,
					stroke: "#6BCABA",
					strokeWidth: 3
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M43.5 36.75H36M43.5 36.75L40.5 33.75M43.5 36.75L40.5 39.75",
					stroke: "#865E9C",
					strokeWidth: 3,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M36.0938 41.4543C34.6798 41.8041 32.719 42 30 42C20.25 42 20.25 39.4816 20.25 36.375C20.25 33.2684 24.6152 30.75 30 30.75C32.2628 30.75 34.3455 31.1947 36 31.9409",
					stroke: "#6BCABA",
					strokeWidth: 3,
					strokeLinecap: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3037_3871",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 60,
				height: 60,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgAssignUser);
export { ForwardRef as ReactComponent };
